import { render, staticRenderFns } from "./ApplicationCopy.vue?vue&type=template&id=c2504f4a"
import script from "./ApplicationCopy.vue?vue&type=script&lang=js"
export * from "./ApplicationCopy.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCopy.vue?vue&type=style&index=0&id=c2504f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports